import axios from "axios";

function computeBackendUrl() {
  const configured = process.env.REACT_APP_BACKEND_URL?.trim();
  if (configured) return configured.replace(/\/+$/, "");
  if (typeof window !== "undefined") {
    const host = window.location.hostname === "127.0.0.1" ? "127.0.0.1" : "localhost";
    return `http://${host}:8001`;
  }
  return "http://localhost:8001";
}

export function getApiErrorMessage(err, fallback = "Errore imprevisto") {
  if (err?.response?.data?.detail) return err.response.data.detail;
  if (err?.code === "ERR_NETWORK") return "Backend non raggiungibile. Verifica che il server sia avviato su porta 8001.";
  if (err?.message?.includes("Network Error")) return "Errore di rete. Controlla backend e CORS.";
  return fallback;
}

const BACKEND_URL = computeBackendUrl();
export const API = BACKEND_URL.endsWith("/api") ? BACKEND_URL : `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_user");
      if (!window.location.pathname.startsWith("/auth")) {
        window.location.href = "/auth/login";
      }
    }
    return Promise.reject(err);
  }
);
